import React from "react";
import { useState, useEffect, useRef } from "react";
import NoDataFound from "../../shared/NoDataFound";
import { useTableState } from "./utils/useTableState";
import ContentDrawer from "./components/ContentDrawer";
import VersionsRow from "./components/VersionsRow";
import ImageModal from "./components/ImageModal";
import TimelineModal from "./components/TimelineModal";
import UploadModal from "./components/UploadModal";
import { timeline, version, more, view_latest_design, view_ad_detauls, chat } from "../../assets/svg";
import { alphaformatDateTime } from "../../utils/dateFormat";
import Loader from "../../shared/Loader";
import TableLoader from "../../shared/TableLoader";
import config from "../../config";
import Select from "react-select";
import Datepicker from "react-tailwindcss-datepicker";
import ContentDetailsCell from "./components/ContentDetailsCell";
import RejectionModal from "./components/RejectionModal";
import ImagesModal from "./components/ImagesModal";
import { renderLocationDetails, renderSalesPersonCell } from "./utils/cellRenderers";
import { useChatContext } from "../../context/ChatContext";
import { useUnreadCountPolling } from "./utils/useUnreadCountPolling";
import { useVisibleRowIds } from "./utils/useVisibleRowIds";

const ProgressAds = ({
  getprogressDesigns,
  progressDesigns,
  setprogressDesigns,
  totalprogress,
  settotalprogress,
  activechild,
  loader,
  tabswitch,
  handlePageChange,
  progressseletedtab,
  setprogressseletedtab,
  initialcount,
  rejectedcount,
  hasMore,
  onLoadMore,
  dateRange,
  setDateRange,
  adType,
  setAdType,
  search,
  setSearch,
}) => {
  const { drawer, actionHandlers, expandedVersionsRow, modal, setModal, currentPage, setCurrentPage, closeExpandedRows } = useTableState();
  const sentinelRef = useRef(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !onLoadMore || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) onLoadMore(); },
      { threshold: 0.1 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, progressDesigns.length]);
  const { openChat } = useChatContext();
  const { visibleIds, rowRef } = useVisibleRowIds();
  const liveUnread = useUnreadCountPolling(progressDesigns, "/user/designer/getUnreadCounts", {
    enabled: activechild === "progress-Ads",
    visibleIds,
  });

  const [showActionsMenu, setShowActionsMenu] = useState(-1);
  const [uploadingidx, setIsUploadingidx] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [rejectionModal, setRejectionModal] = useState({ open: false, adData: null });
  const [showImages, setShowImages] = useState({ open: false, adData: null });

  const tableRef = useRef(null);

  const [selectedCreative, setSelectedCreative] = useState(null);

  useEffect(() => {
    setCurrentPage(0);
    setShowActionsMenu(-1);
  }, [activechild]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showActionsMenu !== -1) {
        // Check if click is outside any actions menu
        const actionsMenus = document.querySelectorAll("[data-actions-menu]");
        let clickedOutside = true;

        actionsMenus.forEach((menu) => {
          if (menu.contains(event.target)) {
            clickedOutside = false;
          }
        });

        if (clickedOutside) {
          setShowActionsMenu(-1);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showActionsMenu]);
  const handleUploadClick = (creativeId, creativeType, idx) => {
    setSelectedCreative({ id: creativeId, type: creativeType, idx });
    setShowUploadModal(true);
  };

  const handleUploadSuccess = (result) => {
    setIsUploadingidx(-1);
    tabswitch("complete-Ads");
  };

  const handleUploadError = (error) => {
    console.error("Upload failed:", error);
  };

  return (
    <div>
      <div>
        <div className="sticky flex gap-4 mb-4">
          <button className={`px-4 py-2 rounded ${progressseletedtab === "initial" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setprogressseletedtab("initial")}>
            Initial Designs <span className="text-black mx-1 py-1 px-2 bg-gray-200 rounded-full">{initialcount || 0}</span>
          </button>
          <button className={`px-4 py-2 rounded ${progressseletedtab === "rejected" ? "bg-blue-600 text-white" : "bg-gray-200"}`} onClick={() => setprogressseletedtab("rejected")}>
            Rejected Designs <span className="text-black mx-1 py-1 px-2 bg-gray-200 rounded-full">{rejectedcount || 0}</span>
          </button>
        </div>
      </div>

      {/* Filter Bar */}

      <div className="overflow-auto">
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Sales Person Details</th>
              <th>Campaign Name</th>
              <th>Location Details</th>
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              {/* <th>Conversation</th> */}
              <th>Upload Design</th>
              <th>Content</th>
              <th>Action</th>
            </tr>
          </thead>
          {progressDesigns.length > 0 && !loader ? (
            progressDesigns.map((rawRow, idx) => {
              const liveCount = liveUnread[rawRow.creative_id];
              const row = liveCount != null ? { ...rawRow, unread_count: liveCount, unreadCount: liveCount } : rawRow;
              const assign_time = alphaformatDateTime(row.assigndate);

              return (
                <tbody key={idx} ref={rowRef(rawRow.creative_id)}>
                  <tr className="border-t">
                    <td className="cursor-pointer hover:bg-green-50" onClick={() => openChat(row)}>
                      {renderSalesPersonCell(row.sales_person,row)}
                    </td>
                    <td>
                      {row.creative_name}
                      <button className="p-1 m-1 bg-gray-200 rounded-lg" onClick={() => setModal({ open: true, type: "latestDesign", image: row.latest_design })}>
                        img
                      </button>
                      {progressseletedtab === "rejected" && (
                        <button className="p-1 m-1 bg-gray-200 rounded-lg" onClick={() => setRejectionModal({ open: true, adData: row })}>
                          reason
                        </button>
                      )}
                    </td>
                    <td>
                    {renderLocationDetails(row)}
                  </td>
                    <td>{row.ad_creative_sub_type}</td>
                    <td>{row.cst_name}</td>
                    <td className="font-bold">
                      <div>{assign_time.dateStr}</div>
                      <div className="text-xs text-gray-500">{assign_time.timeStr}</div>
                    </td>
                    {/* <td>
                    <button className="bg-blue-600 text-white px-5 py-1 rounded">
                      Logs
                    </button>
                  </td> */}
                    <td>
                      {row.status === 5 ? (
                        <div className="py-1 rounded-md w-full bg-reject_text text-white text-center cursor-not-allowed">Rejected</div>
                      ) : (
                        <>
                          {uploadingidx === idx ? (
                            <Loader />
                          ) : ![3, 4, 5].includes(Number(row?.status)) ? null : (
                            <button
                              className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors"
                              onClick={() => handleUploadClick(row.creative_id, row.ad_creative_sub_type, idx)}
                            >
                              Upload Design
                            </button>
                          )}
                        </>
                      )}
                    </td>
                    <td>
                      <ContentDetailsCell creative_id={row.creative_id} />
                    </td>
                    <td className="flex justify-center relative">
                      {showActionsMenu === idx && (
                        <div className="absolute z-10 top-0 right-full flex gap-3 items-center justify-center bg-gray-600 border rounded-md py-2 px-3 space-x-2 w-52" data-actions-menu>
                          <sl-tooltip content="viewLatestDesign" hoist>
                            <img src={view_latest_design} onClick={() => actionHandlers["viewLatestDesign"](row)} alt="viewLatestDesign" className="w-6 h-6 inline-block cursor-pointer" />
                          </sl-tooltip>
                          <sl-tooltip content="version" hoist>
                            <img src={version} onClick={() => actionHandlers["toggleVersions"](idx, expandedVersionsRow)} alt="version" className="w-6 h-6 inline-block cursor-pointer" />
                          </sl-tooltip>
                          <sl-tooltip content="viewTimeline" hoist>
                            <img src={timeline} onClick={() => actionHandlers["viewTimeline"](row)} alt="viewTimeline" className="w-6 h-6 inline-block cursor-pointer" />
                          </sl-tooltip>
                          <sl-tooltip content="View Images" hoist>
                            <img src={view_ad_detauls} onClick={() => setShowImages({ open: true, adData: row })} alt="viewAdDetails" className="w-6 h-6 inline-block cursor-pointer" />
                          </sl-tooltip>
                          <sl-tooltip content="Chat" hoist>
                              <img
                                  src={chat}
                                  alt='chat icon'
                                  onClick={() => openChat(row)}
                              />
                          </sl-tooltip>
                        </div>
                      )}
                      <sl-tooltip content="More actions" hoist>
                        <img src={more} alt="More" className={`w-5 h-5 ${showActionsMenu !== idx ? "rotate-90" : ""}`} onClick={() => setShowActionsMenu((ind) => (ind === idx ? -1 : idx))} />
                      </sl-tooltip>
                    </td>
                  </tr>
                  <VersionsRow row={row} isExpanded={expandedVersionsRow === idx} colSpan={12} onClose={() => closeExpandedRows()} />
                </tbody>
              );
            })
          ) : !progressDesigns.length > 0 && !loader ? (
            <NoDataFound colspan="12" />
          ) : (
            <TableLoader colspan="12" />
          )}
        </table>
      </div>
      {hasMore && !loader && <div ref={sentinelRef} className="h-6 w-full" />}
      {loader && progressDesigns.length > 0 && <div className="flex justify-center py-3"><div className="spinner-border text-primary" role="status" /></div>}

      <ImageModal isOpen={modal.open && modal.type === "latestDesign"} image={modal.image} alt="alt image" onClose={actionHandlers.closeModal} row={modal.row} />
      <TimelineModal isOpen={modal.open && modal.type === "timeline"} row={modal.timelineData} onClose={actionHandlers.closeModal} />
      <ContentDrawer isOpen={drawer.open} type={drawer.type} rowData={drawer.rowData} onClose={actionHandlers.closeDrawer} />
      <UploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        creativeId={selectedCreative?.id}
        creativeType={selectedCreative?.type}
      />
      <RejectionModal isOpen={rejectionModal.open} onClose={() => setRejectionModal({ open: false, adData: null })} adData={rejectionModal.adData} />
      <ImagesModal isOpen={showImages.open} adData={showImages.adData} onClose={() => setShowImages({ open: false, adData: null })} />
    </div>
  );
};

export default ProgressAds;
